var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 50,
    fill: "#E8F2FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9444 80C43.7222 80 42.6756 79.5644 41.8044 78.6933C40.9333 77.8222 40.4985 76.7763 40.5 75.5556V44.4444C40.5 43.2222 40.9356 42.1756 41.8067 41.3044C42.6778 40.4333 43.7237 39.9985 44.9444 40H69.7778C70.3704 40 70.9356 40.1111 71.4733 40.3333C72.0111 40.5556 72.483 40.8704 72.8889 41.2778L79.2222 47.6111C79.6296 48.0185 79.9444 48.4911 80.1667 49.0289C80.3889 49.5667 80.5 50.1311 80.5 50.7222V75.5556C80.5 76.7778 80.0644 77.8244 79.1933 78.6956C78.3222 79.5667 77.2763 80.0015 76.0556 80H44.9444ZM60.5 73.3333C62.3519 73.3333 63.9259 72.6852 65.2222 71.3889C66.5185 70.0926 67.1667 68.5185 67.1667 66.6667C67.1667 64.8148 66.5185 63.2407 65.2222 61.9444C63.9259 60.6481 62.3519 60 60.5 60C58.6481 60 57.0741 60.6481 55.7778 61.9444C54.4815 63.2407 53.8333 64.8148 53.8333 66.6667C53.8333 68.5185 54.4815 70.0926 55.7778 71.3889C57.0741 72.6852 58.6481 73.3333 60.5 73.3333ZM49.3889 55.5556H64.9444C65.5741 55.5556 66.1022 55.3422 66.5289 54.9156C66.9556 54.4889 67.1681 53.9615 67.1667 53.3333V48.8889C67.1667 48.2593 66.9533 47.7311 66.5267 47.3044C66.1 46.8778 65.5726 46.6652 64.9444 46.6667H49.3889C48.7593 46.6667 48.2311 46.88 47.8044 47.3067C47.3778 47.7333 47.1652 48.2607 47.1667 48.8889V53.3333C47.1667 53.963 47.38 54.4911 47.8067 54.9178C48.2333 55.3444 48.7607 55.557 49.3889 55.5556Z",
    fill: "#2E90FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.56831924c8ae3fd97cf707713c8dc2b0.svg";
export { ForwardRef as ReactComponent };